export const ENTRY = 'insurancecardcapture';
export const PATH_NAME = 'ic';
export const BASE_PATH = `/${PATH_NAME}(/:guid)`;
export const PAGE_NAME = 'insurancecardcapture';
export const PAGE_TYPE = 'InsuranceCardCapture';
export const ANALYTICS_NAME = 'InsuranceCardCapture';
export const TITLE = 'Insurance Card Capture';
export const ROLLUP_BUCKET = 'Utility';
